import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import StudioDetails from "./StudioDetails/StudioDetails";
import OtherDetails from "./OtherDetails/OtherDetails";
import Calendar from "../utils/Calendar/Main";
import "./Booking.css";
import {
  getStudioData,
  getBookingData,
  addLeads,
  editLeads,
  getAddons,
  getStudiosOption,
} from "../../services/api/api";
import { ToastContainer } from "react-toastify";
import { showToast } from "../utils/Function/Helper";
import Swal from "sweetalert2";

function Booking({ formData, setFormData, setPopup, setLoadingapi }) {  
  const user = useSelector((state) => state.user);      
  const [bookingData, setBookingData] = useState([]);
  const [studioData, setStudioDAta] = useState({});
  const teamData = [{ id: "1", name: "Team_1" }];
  const [studiosOption, setStudiosOption] = useState([]);
  const [photographerOption, setPhotographerOption] = useState([]);
  const [page, setPage] = useState(0);
  const FormTitles = ["Studio Details", "Slot Details", "Others"];
  const [loading, setLoading] = useState(false); // State for loading
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchStudioData = async (id) => {
      try {
        const data = await getStudioData({superadmin_id: user?.userDetails?.ID || null, id});
        if (data.status) {
          setStudioDAta(data.data);
          setFormData((prevFormData) => ({
            ...prevFormData,
            duration: data.data.duration,
          }));
        } else {
          setStudioDAta({});

          setFormData((prevFormData) => ({
            ...prevFormData,
            duration: "",
          }));
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    getAddons({superadmin_id : user?.userDetails?.ID, source: "photographer"}).then((response) => {
      if (response.status) {
        let prioritylist = response.data.map((item) => {
          return { value: item.id, label: item.source_value };
        });
        setPhotographerOption(prioritylist);
      }
    });

    const fetchStudiosName = async () => {
      try {
        const data = await getStudiosOption(formData);

        if (data.status) {
          setStudiosOption(data.data);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    const fetchBookingData = async () => {
      try {
        const data = await getBookingData(formData);

        if (data.status) {
          setBookingData(data.data);
        } else {
          setBookingData([]);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    if (formData.studio_id) {
      fetchStudioData(formData.studio_id);
      fetchBookingData();
    }
    fetchStudiosName();
  }, [user, formData.studio_id]); // Only runs on initial render

  const validateStep = () => {
    const newErrors = {};
    if (page === 0) {
      if (!formData.studio_id) newErrors.studio_id = "Studio is required";
    } else if (page === 1) {
      if (!formData.local_selected_date)
        newErrors.local_selected_date = "Date is required";
      if (formData.local_selected_date && !formData.slot_time)
        newErrors.slot_time = "Slot is required";
    } else {
      if (!formData.total_budget) {
        newErrors.total_budget = "Total budget is required";
      } else if (isNaN(formData.total_budget) || formData.total_budget <= 0) {
        newErrors.total_budget = "Enter a valid number greater than 0";
      }
      if (!formData.amount_paid) {
        newErrors.amount_paid = "Amount paid is required";
      } else if (isNaN(formData.amount_paid) || formData.amount_paid <= 0) {
        newErrors.amount_paid = "Enter a valid number greater than 0";
      }

      if (!formData.photographer_id)
        newErrors.photographer_id = "Photographer is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const PageDisplay = () => {
    if (page === 0) {
      return (
        <StudioDetails
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          studiosOption={studiosOption}
        />
      );
    } else if (page === 1) {
      return (
        <Calendar
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          setBookingData={setBookingData}
          bookingData={bookingData}
          studioData={studioData}
          teamData={teamData}
        />
      );
    } else {
      return (
        <OtherDetails
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          photographerOption={photographerOption}
        />
      );
    }
  };
  const handleBack = () => {

    if(page === 0){

      Swal.fire({
        title: "Are you want to back?",
        text: "If you have entered any data, it will be lost.",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Okay",
        customClass: {
          title: "swal2-title-custom",
          htmlContainer: "swal2-text-custom",
          confirmButton: "swal2-confirm-button-custom",
        },
      }).then((result) => {
        if(result.isConfirmed){
          setPopup(null);
        }
      });
    }else{
      setPage((currPage) => currPage - 1); // Go to the previous page

    }
  };

  const handleSubmit = async () => {
    if (page === FormTitles.length - 1) {
      if (validateStep()) {
        setLoading(true); // Set loading to true
        formData.local_selected_date = "";
        if (formData.id) {
          const response = await editLeads(formData);
          if (response.status) {
            Swal.fire({
              title: response.message,
              icon: "success",
              confirmButtonColor: "#dc3545",
              confirmButtonText: "Okay",

              customClass: {
                title: "swal2-title-custom",
                htmlContainer: "swal2-text-custom",
                confirmButton: "swal2-confirm-button-custom",
              },
            }).then((result) => {
              setPopup(null);
              setLoadingapi((prev) => !prev);
            });
          } else {
            showToast("warning", response.message);
          }
        } else {
          const response = await addLeads(formData);
          if (response.status) {
            Swal.fire({
              title: response.message,
              icon: "success",
              confirmButtonColor: "#dc3545",
              confirmButtonText: "Okay",

              customClass: {
                title: "swal2-title-custom",
                htmlContainer: "swal2-text-custom",
                confirmButton: "swal2-confirm-button-custom",
              },
            }).then((result) => {
              setPopup(null);
              setLoadingapi((prev) => !prev);
            });
          } else {
            showToast("warning", response.message);
          }
        }
      }
    } else {
      if (validateStep()) {
        setPage((currPage) => currPage + 1); // Go to the next page
      }
    }
  };

  return (
    <div className="booking-container">
      <ToastContainer />

      <div className="form">
        <div className="form-container">
          {/* Progress Step */}
          <div className="progressbar">
            {FormTitles.map((title, index) => {
              // Log the current title and index

              return (
                <div key={index} className="step-container">
                  <div
                    className={`step ${page > index ? "completed" : ""} ${
                      page === index ? "activeprogress" : ""
                    }`}
                  >
                    <span>{page > index ? "✔" : index + 1}</span>{" "}
                    {/* Show checkmark for completed steps */}
                    <p>{title}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Form Title */}
          <div className="slot-header">
            <h1>{FormTitles[page]}</h1>
          </div>

          {/* Form Body */}
          <div className="slot-body">{PageDisplay()}</div>

          {/* Navigation Buttons */}
          <div className="slot-footer">
            <button  onClick={handleBack}>
            {page === 0 ? "Cancel" : "Back"}
            </button>
            <button disabled={loading} onClick={handleSubmit}>
              {page === FormTitles.length - 1 ? "Book a Slot" : "Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Booking;
